import { render, staticRenderFns } from "./qualityTeam.vue?vue&type=template&id=3390f238&scoped=true&"
import script from "./qualityTeam.vue?vue&type=script&lang=js&"
export * from "./qualityTeam.vue?vue&type=script&lang=js&"
import style0 from "./qualityTeam.vue?vue&type=style&index=0&id=3390f238&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3390f238",
  null
  
)

export default component.exports